import { useEffect } from "react";
import FullPageOverlay from "src/components/fullpageoverlay/FullPageOverlay";
import CloseSvg from "src/components/svg/CloseSvg";
import styles from "./SelectorWrapper.module.css";

//#region [Props]
type SelectorWrapperProps = {
	children: React.ReactNode;
	onClose: () => void;
	heading?: string;
};
//#endregion

//#region [Component]
export default function SelectorWrapper({ children, onClose, heading }: SelectorWrapperProps) {
	useEffect(() => {
		const escHandler = (evt: KeyboardEvent) => {
			if (evt.code === "Escape") {
				onClose();
			}
		};

		document.addEventListener("keydown", escHandler, false);

		return () => {
			document.removeEventListener("keydown", escHandler, false);
		};
	}, [onClose]);

	return <FullPageOverlay hideCloseButton>
		<div className={styles.SDialogContent} onClick={(e) => e.stopPropagation()}>
			<button className={styles.SCloseButton} onClick={onClose}>
				<CloseSvg />
			</button>
			{heading && <div className={styles.SHeading}>{heading}</div>}
			{children}
		</div>
	</FullPageOverlay>;
}
//#endregion
